import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { ProductBaseInfoFragmentDoc } from '../../fragments/__generated__/Product.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ResetPasswordMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { data: { errors: Array<{ messages: Array<string>, field: string }> } };

export type MeChangeInfoMutationVariables = Types.Exact<{
  firstName: Types.Scalars['String']['input'];
  email: Types.Scalars['String']['input'];
  lastName: Types.Scalars['String']['input'];
}>;


export type MeChangeInfoMutation = { data: { errors: Array<{ messages: Array<string>, field: string }> } };

export type MeChangePasswordMutationVariables = Types.Exact<{
  oldPassword: Types.Scalars['String']['input'];
  newPassword1: Types.Scalars['String']['input'];
  newPassword2: Types.Scalars['String']['input'];
}>;


export type MeChangePasswordMutation = { data: { errors: Array<{ messages: Array<string>, field: string }> } };

export type AddFavoritesProductMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
}>;


export type AddFavoritesProductMutation = { userAddFavoritesProduct: { errors: Array<string>, product: { id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean } | null } };

export type DeleteFavoritesProductMutationVariables = Types.Exact<{
  pk: Types.Scalars['Int']['input'];
}>;


export type DeleteFavoritesProductMutation = { userDeleteFavoritesProduct: { errors: Array<string>, product: { id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean } | null } };


export const ResetPasswordDocument = gql`
    mutation ResetPassword($email: String!) {
  data: resetPassword(input: {email: $email}) {
    errors {
      messages
      field
    }
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const MeChangeInfoDocument = gql`
    mutation MeChangeInfo($firstName: String!, $email: String!, $lastName: String!) {
  data: userChangeInfo(
    input: {firstName: $firstName, email: $email, lastName: $lastName}
  ) {
    errors {
      messages
      field
    }
  }
}
    `;
export type MeChangeInfoMutationFn = Apollo.MutationFunction<MeChangeInfoMutation, MeChangeInfoMutationVariables>;

/**
 * __useMeChangeInfoMutation__
 *
 * To run a mutation, you first call `useMeChangeInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeChangeInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meChangeInfoMutation, { data, loading, error }] = useMeChangeInfoMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      email: // value for 'email'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useMeChangeInfoMutation(baseOptions?: Apollo.MutationHookOptions<MeChangeInfoMutation, MeChangeInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MeChangeInfoMutation, MeChangeInfoMutationVariables>(MeChangeInfoDocument, options);
      }
export type MeChangeInfoMutationHookResult = ReturnType<typeof useMeChangeInfoMutation>;
export type MeChangeInfoMutationResult = Apollo.MutationResult<MeChangeInfoMutation>;
export type MeChangeInfoMutationOptions = Apollo.BaseMutationOptions<MeChangeInfoMutation, MeChangeInfoMutationVariables>;
export const MeChangePasswordDocument = gql`
    mutation MeChangePassword($oldPassword: String!, $newPassword1: String!, $newPassword2: String!) {
  data: userChangePassword(
    input: {oldPassword: $oldPassword, newPassword1: $newPassword1, newPassword2: $newPassword2}
  ) {
    errors {
      messages
      field
    }
  }
}
    `;
export type MeChangePasswordMutationFn = Apollo.MutationFunction<MeChangePasswordMutation, MeChangePasswordMutationVariables>;

/**
 * __useMeChangePasswordMutation__
 *
 * To run a mutation, you first call `useMeChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMeChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [meChangePasswordMutation, { data, loading, error }] = useMeChangePasswordMutation({
 *   variables: {
 *      oldPassword: // value for 'oldPassword'
 *      newPassword1: // value for 'newPassword1'
 *      newPassword2: // value for 'newPassword2'
 *   },
 * });
 */
export function useMeChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<MeChangePasswordMutation, MeChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MeChangePasswordMutation, MeChangePasswordMutationVariables>(MeChangePasswordDocument, options);
      }
export type MeChangePasswordMutationHookResult = ReturnType<typeof useMeChangePasswordMutation>;
export type MeChangePasswordMutationResult = Apollo.MutationResult<MeChangePasswordMutation>;
export type MeChangePasswordMutationOptions = Apollo.BaseMutationOptions<MeChangePasswordMutation, MeChangePasswordMutationVariables>;
export const AddFavoritesProductDocument = gql`
    mutation AddFavoritesProduct($pk: Int!) {
  userAddFavoritesProduct(pk: $pk) {
    errors
    product {
      ...ProductBaseInfoFragment
    }
  }
}
    ${ProductBaseInfoFragmentDoc}`;
export type AddFavoritesProductMutationFn = Apollo.MutationFunction<AddFavoritesProductMutation, AddFavoritesProductMutationVariables>;

/**
 * __useAddFavoritesProductMutation__
 *
 * To run a mutation, you first call `useAddFavoritesProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoritesProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoritesProductMutation, { data, loading, error }] = useAddFavoritesProductMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useAddFavoritesProductMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoritesProductMutation, AddFavoritesProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoritesProductMutation, AddFavoritesProductMutationVariables>(AddFavoritesProductDocument, options);
      }
export type AddFavoritesProductMutationHookResult = ReturnType<typeof useAddFavoritesProductMutation>;
export type AddFavoritesProductMutationResult = Apollo.MutationResult<AddFavoritesProductMutation>;
export type AddFavoritesProductMutationOptions = Apollo.BaseMutationOptions<AddFavoritesProductMutation, AddFavoritesProductMutationVariables>;
export const DeleteFavoritesProductDocument = gql`
    mutation DeleteFavoritesProduct($pk: Int!) {
  userDeleteFavoritesProduct(pk: $pk) {
    errors
    product {
      ...ProductBaseInfoFragment
    }
  }
}
    ${ProductBaseInfoFragmentDoc}`;
export type DeleteFavoritesProductMutationFn = Apollo.MutationFunction<DeleteFavoritesProductMutation, DeleteFavoritesProductMutationVariables>;

/**
 * __useDeleteFavoritesProductMutation__
 *
 * To run a mutation, you first call `useDeleteFavoritesProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoritesProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoritesProductMutation, { data, loading, error }] = useDeleteFavoritesProductMutation({
 *   variables: {
 *      pk: // value for 'pk'
 *   },
 * });
 */
export function useDeleteFavoritesProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoritesProductMutation, DeleteFavoritesProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoritesProductMutation, DeleteFavoritesProductMutationVariables>(DeleteFavoritesProductDocument, options);
      }
export type DeleteFavoritesProductMutationHookResult = ReturnType<typeof useDeleteFavoritesProductMutation>;
export type DeleteFavoritesProductMutationResult = Apollo.MutationResult<DeleteFavoritesProductMutation>;
export type DeleteFavoritesProductMutationOptions = Apollo.BaseMutationOptions<DeleteFavoritesProductMutation, DeleteFavoritesProductMutationVariables>;